<template>
  <div id="app">
    <header>
      <CommonHeader />
    </header>
    <main>
      <CommonMain />
      <router-view />
    </main>
    <aside>
    </aside>
    <footer>
      <hr>
      <p><small>&copy; 2019 株式会社盛香堂石田商店</small></p>
    </footer>
  </div>
</template>

<script>
import { CommonHeader, CommonMain } from '@/components/Common';
import eventHub from '@/utils/eventHub';

export default {
  components: { CommonHeader, CommonMain },
  mounted() {
    eventHub.$on('logout', () => {
      this.$store.dispatch('auth/logout');
      this.$router.push('/auth/login', () => {}, () => {});
    });
  },
}
</script>

<style>
body {
  /*background-color: #efe !important;*/
  padding: 4.5rem 5% 1rem 5%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1 {
  text-align: center;
}

footer {
  text-align: center;
}

.btn {
  margin-right: 5px;
}

.btn-group .btn, .input-group .btn {
  margin-right: 0;
}

.Password {
  max-width: none !important;
  margin: auto !important;
}
</style>
